import { useEffect, useState } from "react";

/**
 * Bespoke gold cursor for desktop.
 * Ring lags behind the dot for a smooth luxury feel.
 * Automatically enlarges over [data-cursor="hover"] elements.
 */
export default function CustomCursor() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [ringPos, setRingPos] = useState({ x: -100, y: -100 });
    const [hover, setHover] = useState(false);

    useEffect(() => {
        let raf;
        const move = (e) => {
            setPos({ x: e.clientX, y: e.clientY });
            const el = document.elementFromPoint(e.clientX, e.clientY);
            const target = el?.closest?.(
                'a, button, [data-cursor="hover"], input, textarea, select',
            );
            setHover(!!target);
        };
        const tick = () => {
            setRingPos((p) => ({
                x: p.x + (pos.x - p.x) * 0.18,
                y: p.y + (pos.y - p.y) * 0.18,
            }));
            raf = requestAnimationFrame(tick);
        };
        window.addEventListener("mousemove", move);
        raf = requestAnimationFrame(tick);
        return () => {
            window.removeEventListener("mousemove", move);
            cancelAnimationFrame(raf);
        };
    }, [pos.x, pos.y]);

    return (
        <>
            <div
                className="cursor-dot"
                style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)` }}
                data-testid="cursor-dot"
            />
            <div
                className={`cursor-ring ${hover ? "hover" : ""}`}
                style={{
                    transform: `translate(${ringPos.x}px, ${ringPos.y}px) translate(-50%, -50%)`,
                }}
                data-testid="cursor-ring"
            />
        </>
    );
}
